import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Div, Form, Text } from "../../StyledComponents";
import { Ptag, Label, InputBox, Break } from "./styles";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import TopNav from "../../TopNav";
import {
  GetCheckPortalPassword,
  GetResetPassword,
  SetCheckPortalPassword,
  SetResetPassword,
} from "../../../StateManagement/Reducers/SettingState";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";
import Error from "../../StyledComponents/Toastify/Error";
import Success from "../../StyledComponents/Toastify/Success";
import { RiArrowLeftLine } from "react-icons/ri";
const ChangePassword = () => {
  // ------------------------------ State and Variables Start---------------------------------------------------  //

  const [curPass, setCurPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [isConfirmPass, setIsConfirmPass] = useState(true);
  const [isNewPass, setIsNewPass] = useState(true);
  const [err, setErr] = useState({
    misPassErr: false,
    samePassErr: false,
    prevPassErr: false,
    newPassEmp: false,
    confirmPassEmp: false,
    curPassEmp: false,
    regexNewPassErr: false,
  });

  const dispatch = useDispatch();
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-\=[\]{};':"|,.<>/?]).{8,}$/;
  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  const CheckPassword = useSelector(
    (state) => state.Setting.CheckPortalPassword,
  );
  const ResetPassword = useSelector((state) => state.Setting.ResetPassword);
  // ------------------------------ State and Variables End---------------------------------------------------  //

  //-------------------------------- Function Start ------------------------------------------------------//

  const handleCurPass = (e) => {
    setCurPass(e.target.value);
    setErr((prevErr) => ({
      ...prevErr,
      prevPassErr: false,
      samePassErr: false,
      curPassEmp: false,
    }));
  };
  const handleNewPass = (e) => {
    setErr((prevErr) => ({
      ...prevErr,
      prevPassErr: false,
      newPassEmp: false,
      regexNewPassErr: false,
    }));
    setNewPass(e.target.value);
    dispatch(SetResetPassword(""));
  };

  const handleConfirmPass = (e) => {
    setErr((prevErr) => ({
      ...prevErr,
      confirmPassEmp: false,
      misPassErr: false,
    }));

    setConfirmPass(e.target.value);
    dispatch(SetResetPassword(""));
  };

  const handleIsNewPass = () => {
    setIsNewPass(false);
  };

  const handleIsConfirmPass = () => {
    setIsConfirmPass(false);
  };

  const handleIsNewPass1 = () => {
    setIsNewPass(true);
  };

  const handleIsConfirmPass1 = () => {
    setIsConfirmPass(true);
  };

  const iconStyle = {
    position: "absolute",
    top: "42px",
    left: "291px",
    cursor: "pointer",
  };
  const handleResetPass = (e) => {
    e.preventDefault();
    if (curPass === "") {
      setErr((prevErr) => ({
        ...prevErr,
        curPassEmp: true,
      }));
      toast(<Error msg="Please Enter Current Password" />, {
        containerId: "B",
        className: "error_badge",
      });
      return false;
    } else if (CheckPassword === "Both Passwords are not same") {
      setErr((prevErr) => ({
        ...prevErr,
        samePassErr: true,
      }));
      toast(
        <Error msg="Current password should be same as Existing Password" />,
        {
          containerId: "B",
          className: "error_badge",
        },
      );
      return false;
    } else if (newPass === "") {
      setErr((prevErr) => ({
        ...prevErr,
        newPassEmp: true,
      }));
      toast(<Error msg="Please Enter New Password" />, {
        containerId: "B",
        className: "error_badge",
      });
      return false;
    } else if (!regex.test(newPass)) {
      setErr((prevErr) => ({
        ...prevErr,
        regexNewPassErr: true,
      }));
      toast(<Error msg="Please Enter Valid New Password" />, {
        containerId: "B",
        className: "error_badge",
      });
      return false;
    } else if (
      ResetPassword === "The password you entered must not be an old password"
    ) {
      setErr((prevErr) => ({
        ...prevErr,
        prevPassErr: true,
      }));
      toast(
        <Error msg="The password you entered must not be an old password" />,
        {
          containerId: "B",
          className: "error_badge",
        },
      );
      return false;
    } else if (confirmPass === "") {
      setErr((prevErr) => ({
        ...prevErr,
        confirmPassEmp: true,
      }));
      toast(<Error msg="Please Enter Confirm Password" />, {
        containerId: "B",
        className: "error_badge",
      });
      return false;
    } else if (newPass !== confirmPass) {
      setErr((prevErr) => ({
        ...prevErr,
        misPassErr: true,
      }));
      toast(<Error msg="New Password and Confirm Password should be same" />, {
        containerId: "B",
        className: "error_badge",
      });
      return false;
    }

    const article = {
      pid: Pat_ID,
      curPass: curPass,
      newPass: newPass,
      confirmPass: confirmPass,
    };
    dispatch(GetResetPassword(article));
  };
  //-----------------------------Function End-------------------------------------------------//

  //-----------------------------UseEffect Start----------------------------------------------//
  useEffect(() => {
    if (curPass) {
      const delayDebounceFn = setTimeout(() => {
        dispatch(GetCheckPortalPassword({ pid: Pat_ID, curPass: curPass }));
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [curPass]);

  useEffect(() => {
    if (ResetPassword === "Success") {
      toast(<Success msg="Password Changed Successfully" />, {
        containerId: "A",
      });
      setCurPass("");
      setNewPass("");
      setConfirmPass("");
      setTimeout(() => {
        dispatch(SetResetPassword(""));
      }, 1500);
    } else if (
      ResetPassword === "The password you entered must not be an old password"
    ) {
      setErr((prevErr) => ({
        ...prevErr,
        prevPassErr: true,
      }));
      toast(
        <Error msg="The password you entered must not be an old password" />,
        {
          containerId: "B",
          className: "error_badge",
        },
      );
      setTimeout(() => {
        dispatch(SetResetPassword(""));
      }, 1500);
    }
    return () => dispatch(SetCheckPortalPassword(""));
  }, [ResetPassword]);

  //-----------------------------UseEffect End----------------------------------------------//

  return (
    <>
      <TopNav title="Settings" />
      <Div
        margin="5px 10px"
        backColor="#FFFFFF"
        minHeight="500px"
        borderRadius="12px"
        padding="24px"
      >
        <Div display="flex" alignItems="center" marginBottom="20px">
          <RiArrowLeftLine
            size="22"
            style={{ cursor: "pointer", marginRight: "8px" }}
            onClick={() => window.history.back()}
          />
          <Div fontSize="18px" fontWeight="600">
            Change Password
          </Div>
        </Div>
        <Form onSubmit={handleResetPass}>
          <Div marginBottom="16px">
            <Label>Current Password</Label>
            <Break />
            <InputBox
              type="password"
              autoComplete="off"
              paddingRight="10px"
              value={curPass}
              onChange={handleCurPass}
              style={
                err.samePassErr || err.curPassEmp || err.prevPassErr
                  ? { border: "1px solid red" }
                  : {}
              }
            />
          </Div>
          <Div marginBottom="16px" position="relative">
            <Label>New Password</Label> <Break />
            <InputBox
              paddingRight="35px"
              autoComplete="off"
              type={isNewPass ? "password" : "text"}
              value={newPass}
              onChange={handleNewPass}
              style={
                err.prevPassErr || err.newPassEmp || err.regexNewPassErr
                  ? { border: "1px solid red" }
                  : {}
              }
            />
            {isNewPass ? (
              <FaRegEyeSlash style={iconStyle} onClick={handleIsNewPass} />
            ) : (
              <FaRegEye style={iconStyle} onClick={handleIsNewPass1} />
            )}
            <Break />
            <Text fontSize="10px" textAlign="left" width="320px">
              Must be atleast 8 characters
            </Text>
          </Div>
          <Div marginBottom="24px" position="relative">
            <Label>Confirm Password</Label> <Break />
            <InputBox
              autoComplete="off"
              paddingRight="35px"
              type={isConfirmPass ? "password" : "text"}
              value={confirmPass}
              onChange={handleConfirmPass}
              style={
                err.misPassErr || err.confirmPassEmp
                  ? { border: "1px solid red" }
                  : {}
              }
            />
            {isConfirmPass ? (
              <FaRegEyeSlash style={iconStyle} onClick={handleIsConfirmPass} />
            ) : (
              <FaRegEye style={iconStyle} onClick={handleIsConfirmPass1} />
            )}
            <Break />
            <Text fontSize="10px" textAlign="left">
              Both password must match
            </Text>
          </Div>
          <Button
            padding="10px 112px 10px 112px"
            height="42px"
            background="#407BFF"
            color="#FFF"
          >
            <Ptag>Reset Password</Ptag>
          </Button>
        </Form>
      </Div>
    </>
  );
};

export default ChangePassword;
